<script setup>
import { Hints, Accordion, AccordionItem, Tutorial, ImageBox } from '@components'
const { sprintf } = wp.i18n
</script>

<template>
    <Row space gap="5">
        <Heading class="text-center">{{__('Display Dark Mode switch using WordPress widget', 'wp-dark-mode')}}<Hints>{{__('Please follow the steps below', 'wp-dark-mode')}}
            </Hints>
        </Heading>

        <Accordion>
            <AccordionItem name="Add the WP Dark Mode widget to the menu">
                <Row class="max-w-xl">
                    <Hints>Navigate to the Widget option in the WordPress dashboard under Appearance menu. Select the menu where you want to display dark mode switch and click on the ‘+’ button and type <span class="text-[#374151]"> Dark Mode Switch</span> in the widget searchbox</Hints>
                        <ImageBox name="settings/switch-widget-1.png" />
                </Row>
            </AccordionItem>

            <AccordionItem name="Select a switch style for the menu">
                <Row class="max-w-xl">
                    <Hints> {{__('Click on the WP Darkmode Widget and you will see the available switches on the right side of the screen. Select the one that you like', 'wp-dark-mode')}}</Hints>
                    <ImageBox name="settings/switch-widget-2.png" />
                </Row>
            </AccordionItem>

            <AccordionItem name="Click update and you are done!">
                <Row class="max-w-xl">
                    <Hints>{{__('Click update and you are done! The switch will now be visible in the menu where you placed.', 'wp-dark-mode')}}</Hints>
                    <ImageBox name="settings/switch-widget-3.png" />
                </Row>
            </AccordionItem>
        </Accordion>

        

        <Tutorial 
            YouTubeId="bvq_UfucI-I"
        />
</Row></template>

<style scoped>
/*
  Enter and leave animations can use different
  durations and timing functions.
*/
.slide-enter-active {
    transition: all 0.3s ease-out;
  }
  
  .slide-leave-active {
    transition: 0s;
    opacity: 0;
  }
  
  .slide-enter-from,
  .slide-leave-to {
    transform: translateY(20px);
    opacity: 0;
  }
</style>